import { fg } from '@atlassian/jira-feature-gating';
import { sidebarFiltersGlobalResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/filters/index.tsx';
import { getWillShowNav3 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav3.tsx';
import { isNinGlobalScopeEnrolmentEnabledResource } from '@atlassian/jira-router-resources-is-nin-global-scope-enrolment-enabled/src/index.tsx';
import {
	issueNavigatorRelayResource,
	issueNavigatorFilterRelayResource,
	issueNavigatorHydrationRelayResource,
	issueNavigatorHydrationRelayResourceBrowserOnly,
} from '@atlassian/jira-router-resources-issue-navigator/src/index.tsx';
import { navigationSidebarGlobalResource } from '@atlassian/jira-router-resources-navigation-sidebar-global/src/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { resourceWithCondition2 } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import { aiContextPanelResource } from '@atlassian/jira-servicedesk-ai-context-panel-resources/src/services/index.tsx';

export const getCommonGlobalResources = () => [
	issueNavigatorRelayResource,
	issueNavigatorFilterRelayResource,
	resourceWithCondition2(
		() => fg('nin_request_hydrate_query_earlier') && !fg('render_jql_builder_in_ssr'),
		issueNavigatorHydrationRelayResourceBrowserOnly,
	),
	resourceWithCondition2(
		() => fg('render_jql_builder_in_ssr'),
		issueNavigatorHydrationRelayResource,
	),
	...getNavigationResources(),
	navigationSidebarGlobalResource,
	isNinGlobalScopeEnrolmentEnabledResource,
	resourceWithCondition2(getWillShowNav3, sidebarFiltersGlobalResource),
	aiContextPanelResource,
];
